module.exports = __webpack_public_path__ + "static/img/testimony (7).1e41cbc2.jpg";